import axios from 'axios';
import api from './endpoints'

export default {
    assignAnimator(args) {
        return axios.put(api.resolveEndpoint(api.ASSIGN_GROUP_ANIMATOR, [args.eventId]), args);
    },
}